import quillConfig from '@/quill/config'

/**
 * Toolbar for the WhatsApp composer / auto-reply / template editor. WhatsApp only
 * supports *bold*, _italic_, ~strikethrough~ and lists — no underline, headings,
 * alignment or links as markup (URLs are auto-linked as plain text). The HTML this
 * produces is converted to WhatsApp's text markers server-side
 * (App\Services\Communication\WhatsApp\WhatsAppTextFormatter).
 *
 * The `placeholder` tool is the shared one (same one the signature editor uses):
 * it drops a `{{ … }}` variable pill from a searchable toolbar dropdown. In the template
 * editor those pills are numbered into Meta's positional {{1}}, {{2}} on submit. The
 * button only appears when the host passes a non-empty `placeholder.variables` list, so the
 * plain composer (no variables) never shows it.
 */
const whatsappQuillConfig = {
    ...quillConfig,
    modules: {
        ...quillConfig.modules,
        toolbar: {
            container: [
                ['bold', 'italic', 'strike'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['placeholder'],
                ['text-generation'],
                ['clean']
            ]
        }
    }
}

export default whatsappQuillConfig
